function padTo2Digits(num: number) {
  return num.toString().padStart(2, '0');
}

/**
 * 格式化日期
 * @param date
 */
export function formatDate(date: any) {
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join('-') +
    ' ' +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes()),
      padTo2Digits(date.getSeconds()),
    ].join(':')
  );
}

/**
 * 获取日期
 * @param date
 */
export function getDate(date: any) {
  const dateTime = formatDate(date);
  const [dt] = dateTime.split(' ');
  return dt;
}

/**
 * 获取时间
 * @param date
 */
export function getTime(date: any) {
  const dateTime = formatDate(date);
  const [, tm] = dateTime.split(' ');
  return tm;

}
